import React, { useRef } from 'react';
import { Popover, Skeleton } from 'antd';
import { CloseCircleOutlined, DownOutlined, ExportOutlined, FolderOpenFilled } from '@ant-design/icons';
import { Header } from 'antd/es/layout/layout';
import { useNavigate } from 'react-router-dom';
import SideNavigation from '../SideNavigation/SideNavigation';
import styled from 'styled-components';
import SquareUpRight from 'assets/square-up-right.svg';
import { useChatState } from '../state/chatState';
import moment from 'moment';
interface DealHeaderProps {
  currentSessionId: any;
  projectName: string;
  dealId: string;
  salesforceDealName: string;
  client: string;
  supplier: string;
  dealType: string;
  category: string;
  type: string;
}
const Wrapper = styled.div`
  .ant-popover-inner-content {
    padding: 0 !important;
    max-width: 350px;
  }
`;
const DealHeader: React.FC<DealHeaderProps> = ({
  currentSessionId,
  dealId,
  salesforceDealName,
  projectName,
  client,
  supplier,
  dealType,
  category,
  type
}) => {
  const popupContainerRef = useRef<HTMLDivElement>(null);
  const { closeEmbeddedWindow, state, setIsDocumentMode } = useChatState();
  const { isMessageLoading } = state.isLoading;
  const navigate = useNavigate();

  const handleNavigation = (route: 'juggernaut' | 'deal_details') => {
    setIsDocumentMode(false);
    if (type === 'embedded' || type === 'horizontal') {
      closeEmbeddedWindow();
    }
    const path =
      route === 'juggernaut'
        ? `/sb/juggernaut?contractId=${dealId}&sessionId=${currentSessionId.id}`
        : `/deal_details/${dealId}?sessionId=${currentSessionId.id}`;
    navigate(path);
  };

  return (
    <Header className="!bg-white !p-1 !h-[44px] flex items-center justify-between">
      <div className="flex items-center min-w-0 flex-1">
        {(type === 'embedded' || type === 'horizontal') && (
          <Wrapper ref={popupContainerRef}>
            <Popover
              content={<SideNavigation mode={type as 'embedded' | 'standalone'} />}
              trigger={['click']}
              getPopupContainer={() => popupContainerRef.current || document.body}
            >
              <div className="flex items-center cursor-pointer hover:text-blue-500">
                <FolderOpenFilled className="text-xl" />
                <DownOutlined className="text-sm ml-1 mr-2" />
              </div>
            </Popover>
          </Wrapper>
        )}
        <div className={`flex flex-col min-w-0 flex-1`}>
          {isMessageLoading ? (
            <Skeleton active paragraph={{ rows: 1 }} className="w-full mt-5" />
          ) : //if deal it is deal catagory show the deal name and project name else show the client and supplier and deal type
          currentSessionId && currentSessionId.category == 'DEAL' ? (
            <>
              <div
                className={`font-bold truncate ${type === 'embedded' || type === 'horizontal' ? 'text-sm' : 'text-lg'}`}
                title={`${salesforceDealName ? `${salesforceDealName} - ` : ''} ${projectName}`}
              >
                {salesforceDealName ? `${salesforceDealName} - ` : ''} {projectName}
              </div>
              <div
                className={`text-gray-500 break-words truncate ${
                  type === 'embedded' || type === 'horizontal' ? 'text-xs' : 'text-sm'
                }`}
                title={`${client}${supplier ? ` | ${supplier}` : ''}${dealType ? ` | ${dealType}` : ''}`}
              >
                {client}
                {supplier ? ` | ${supplier}` : ''}
                {dealType ? ` | ${dealType}` : ''}
              </div>
            </>
          ) : (
            <>
              <div
                className={`font-bold truncate ${type === 'embedded' || type === 'horizontal' ? 'text-sm' : 'text-lg'}`}
              >
                {currentSessionId?.project?.chatSessions?.[moment(currentSessionId?.updatedAt).format('YYYY-MM-DD')]?.[
                  currentSessionId?.index
                ]?.title || ''}
              </div>
              <div
                className={`text-gray-500 break-words truncate ${
                  type === 'embedded' || type === 'horizontal' ? 'text-xs' : 'text-sm'
                }`}
                title={`${supplier ? `${supplier} | ${dealType}` : ''}`}
              >
                {supplier ? `${supplier} | ${dealType}` : ''}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="flex items-center space-x-2">
        {isMessageLoading ? (
          <Skeleton.Button active size="small" className="w-[100px] mt-2" />
        ) : type === 'embedded' || type === 'horizontal' ? (
          <button onClick={() => handleNavigation('juggernaut')} className="ant-btn ant-btn-link">
            <img title="Go to Juggernaut" src={SquareUpRight} alt="Open in new window" className="w-[18px] h-[18px]" />
          </button>
        ) : (
          // dont show the button if the session is not a deal
          currentSessionId &&
          currentSessionId.category == 'DEAL' && (
            <button onClick={() => handleNavigation('deal_details')} className="ant-btn ant-btn-link">
              <ExportOutlined className="text-xs mr-2" />
              Deal Details
            </button>
          )
        )}
        {(type === 'embedded' || type === 'horizontal') && (
          <CloseCircleOutlined
            className="text-xl cursor-pointer hover:text-red-500"
            onClick={() => closeEmbeddedWindow()}
          />
        )}
      </div>
    </Header>
  );
};

export default DealHeader;
